module.exports = __webpack_public_path__ + "static/media/Groovy_para_procesamiento_en_lote.ca26c83c.png";